<template>
  <router-view v-if="isRouterAlive" v-slot="{ Component }">
    <!-- include包含需要缓存的控件名称 -->
    <keep-alive :include="[]">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<style>
.hide {
  display: none!important;
}
.van-list {
  min-height: calc(100vh - 158px);
}
.btn-2 {
  width: 100%;
  margin: 0 1%; 
}
.btn-group {
  padding: 12px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
}
.btn-group button {
  width: 100%;
  margin: 0 1%; 
}
.van-nav-bar {
  z-index: 2;
}
.van-nav-bar__title {
  width: 60%;
}
.title-tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tag-group .van-tag {
  margin-right: 5px;
}
.van-toast {
  background-color: rgba(0,0,0,.7)!important;
}
.center {
  text-align: center;
}
</style>

<script>
import { nextTick, provide, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const DEBUG = true;

export default {
  setup() {

    const isRouterAlive = ref(true);
    const router = useRouter();
    const route = useRoute();

    // 定义工具对象
    const common = {
      /**
       * Route&Router
       */
      route: route,
      router: router,
      /**
       * 路由替换
       */
      replace: function(url) {
        router.replace(url);
      },
      /**
       * 路由重定向
       */
      redirect: function(url) {
        router.push(url);
      },
      /**
       * 路由后退
       */
      back: function() {
        router.go(-1);
      },
      /**
       * 路由前进/后退
       */
      go: function(index = -1) {
        router.go(index);
      },
      /**
       * 刷新当前页，只刷新组件，不刷新页面
       */
      reload: function() {
        setTimeout(() => {
          isRouterAlive.value = false;
          nextTick(() => {
            isRouterAlive.value = true;
          });
        }, 1);
      },
      /**
       * 增加组件刷新标记
       */
      refresh_tag: function() {
        !DEBUG || console.log('增加组件刷新标记++++++');
        localStorage.setItem('refresh', '1');
      },
      /**
       * 删除组件刷新标记
       */
      remove_refresh_tag: function() {
        !DEBUG || console.log('删除组件刷新标记-------');
        localStorage.removeItem('refresh');
      },
      /**
       * 根据刷新标记判断是否需要刷新组件
       */
      refresh: function() {
        !DEBUG || console.log('根据刷新标记判断是否需要刷新组件');
        let needRefresh = localStorage.getItem('refresh');
        if (needRefresh === '1') {
          !DEBUG || console.log('刷新');
          localStorage.removeItem('refresh');
          common.reload();
        }
      },
    };

    // 提供子控件使用工具对象
    provide('common', common);

    return {
      isRouterAlive,
    };
  },
}

// 对Date的扩展，将 Date 转化为指定格式的String   
// 月(M)、日(d)、小时(H)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，   
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)   
// 例子：   
// (new Date()).Format("yyyy-MM-dd HH:mm:ss.S") ==> 2006-07-02 08:09:04.423   
// (new Date()).Format("yyyy-M-d H:m:s.S")      ==> 2006-7-2 8:9:4.18   
Date.prototype.Format = function(fmt)   
{ //author: meizz   
  var o = {   
    "M+" : this.getMonth()+1,                 //月份   
    "d+" : this.getDate(),                    //日   
    "h+" : this.getHours(),                   //小时   
    "m+" : this.getMinutes(),                 //分   
    "s+" : this.getSeconds(),                 //秒   
    "q+" : Math.floor((this.getMonth()+3)/3), //季度   
    "S"  : this.getMilliseconds()             //毫秒   
  };   
  if(/(y+)/.test(fmt))   
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));   
  for(var k in o)   
    if(new RegExp("("+ k +")").test(fmt))   
  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));   
  return fmt;   
}
</script>